module.exports = __webpack_public_path__ + "img/minus-icon.7279d4ef.svg";